import axios from 'axios'
import qs from 'qs'

const service = axios.create({
    timeout: 20000
})

service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        console.log('err' + error)
        return Promise.reject(error)
    }
)

function get(url, params) {
    return new Promise((resolve, reject) => {
        service.get(url, {params})
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                console.error(err)
                console.error(err.message)
                reject(err)
            })
    });
}

function postForm(url, params) {
    return new Promise((resolve, reject) => {
        service.post(url, qs.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            }
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                console.error(err)
                console.error(err.message)
                reject(err)
            })
    });
}

function postJson(url, params, headers) {
    return new Promise((resolve, reject) => {
        var _headers = {
            'Content-Type': 'application/json; charset=utf-8'
        }
        if (headers) {
            _headers = {...headers, ..._headers}
        }
        service.post(url, params, {
            headers: _headers
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    })
}

function uploadFile(url, fileData) {
    return new Promise((resolve, reject) => {
        service.post(url, fileData).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    })
}

export default service

export {
    get,
    postJson,
    postForm,
    uploadFile
}
